

import React, { useEffect, useRef, useState } from "react";
import Navbar from "../Navbar/Navbar";
import { FaFacebook, FaLinkedin, FaTwitter } from "react-icons/fa";
import "./style.css";
import Footer from "../Footer/Footer";
import AOS from 'aos';
import 'aos/dist/aos.css';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/grid';
import 'swiper/css/autoplay';
import { Autoplay, Grid } from 'swiper/modules';
import CountUp from 'react-countup';
import slide1 from '../Images/slider-1.jpg'
import slide2 from '../Images/slider-2.jpg'
import slide3 from '../Images/slider-3.jpg'
import slide4 from '../Images/slider-4.jpg'
import slide5 from '../Images/slider-5.jpg'
import slide6 from '../Images/slider-6.jpg'
import slide7 from '../Images/slider-7.jpg'
import slide8 from '../Images/slider-7.jpg'
import slide9 from '../Images/slider-9.jpg'
import slide10 from '../Images/slider-10.jpg'
import { useNavigate } from "react-router-dom";

import acuast from '../acuast.png';
import cam from '../cam.png';
import data from '../data.png';
import graph from '../graph.png';
import it from '../Services/nvy7t81j.png';
import youtube from '../youtube.png';
import client1 from '../Images/client1.png';
import client2 from '../Images/client2.png';
import client3 from '../Images/client3.png';
import client4 from '../Images/client4.png';
import client5 from '../Images/client1.png';
import client6 from '../Images/client2.png';
import client7 from '../Images/client3.png';
import client8 from '../Images/client4.png';
import client9 from '../Images/client4.png';
import client10 from '../Images/client4.png';
import HeroSlider from "./HeroSlider";
import AboutSection from "./AboutSection";
import ServicesSection from "./ServicesSection";
import WhyChooseUs from "./WhyChooseUs";
import FloatingScrollCTA from "./FloatingScrollCTA";
import axios from "axios";






const Home = () => {

    const navigate = useNavigate();
const services = [
  {
    title: "Building Acoustics",
    img: acuast,
    link: "/buildingAcoustics",
  },
  {
    title: "AV Solutions",
    img:  youtube,
    link: "/av",
  },
  {
    title: "IT/ICT & Data Centers",
    img: it,
    link: "/it",
  },
  {
    title: "Security Risk Assessment",
    img:data,
    link: "/security-risk",
  },
  {
    title: "Security Systems",
    img: cam,
    link: "/security",
  },
  {
    title: "Project Management",
    img:  graph,
    link: "/pm",
  },
];
//  const slides = [
//     { id: 1, title: "King Salman Park - 2 Mosque & Post Office", location: "Kingdom of Saudi Arabia", link: "projects/king_salman.html", bgImage: slide1 },
//     { id: 2, title: "The Island Project - The MGM, Bellagio & Aria Hotels", location: "United Arab Emirates", link: "projects/island_project.html", bgImage: slide2 },
//     { id: 3, title: "W Hotel and ALEF Residences, The Palm, Dubai", location: "United Arab Emirates", link: "projects/w_hotel.html", bgImage:slide3 },
//     { id: 4, title: "King Abdul Aziz Road (KAAR) – 2 Kempinski, 1 Taj & 1 Hilton Hotels", location: "Kingdom of Saudi Arabia", link: "projects/king_abdul.html", bgImage: slide4 },
//     { id: 5, title: "Avenues Riyadh - Hilton Hotel, Residential & Office Tower", location: "Kingdom of Saudi Arabia", link: "projects/avenue_riyadh.html", bgImage: slide5 },
//     { id: 6, title: "New Palace of Justice", location: "Kuwait", link: "projects/new_palace.html", bgImage: slide6},
//     { id: 7, title: "Sabah Al Salem Stadium", location: "Kuwait", link: "projects/sabah_al.html", bgImage: slide7},
//     { id: 8, title: "Retal Ritz Carlton Resort", location: "Kingdom of Saudi Arabia", link: "projects/retal_ritz.html", bgImage:slide8 },
//     { id: 9, title: "Yas w Hotel Refurbishment, Abu Dhabi", location: "United Arab Emirates", link: "projects/yes_w.html", bgImage: slide9},
   
//   ];


// const clientLogos = [client1, client2, client3, client4, client5, client6, client7, client8, client9, client10];


const [clients, setClients] = useState([]);
const [slides, setSlides] = useState([]);
const [loading, setLoading] = useState(true);


useEffect(() => {
  AOS.init({ duration: 1000, once: true });
}, []);

  const [activeSlide, setActiveSlide] = useState(0);
    const maxVisibleDots = 4;

// Calculate start and end indexes based on current slide
const startDot = Math.max(0, Math.min(activeSlide - 1, slides.length - maxVisibleDots));
const visibleSlides = slides.slice(startDot, startDot + maxVisibleDots);

  // Auto-scroll slides
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveSlide((prev) => (prev + 1) % slides.length); // Loop through slides
    }, 3000); // Change every 3 seconds

    return () => clearInterval(interval);
  }, []);

  const [startIndex, setStartIndex] = useState(0);
  const containerRef = useRef(null);

  // Auto slide every 3 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setStartIndex((prev) =>
        prev + 1 >= slides.length ? 0 : prev + 1
      );
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  // To get visible cards: 8 cards visible (4 per row * 2 rows)
  const visibleCount = 8;

  // Calculate indices to show cards in slider, looping around
  const getVisibleProjects = () => {
    let visible = [];
    for (let i = 0; i < visibleCount; i++) {
      visible.push(slides[(startIndex + i) % slides.length]);
    }
    return visible;
  };

  const visibleProjects = getVisibleProjects();


  useEffect(() => {
  axios.get("https://infosightapi.emedha.in/api/clients")
    .then(res => {
      setClients(res.data);
      setLoading(false);
    })
    .catch(err => {
      console.log(err);
      setLoading(false);
    });
}, []);


useEffect(() => {
  async function fetchSlides() {
    try {
      const res = await fetch("https://infosightapi.emedha.in/api/projects");
      const data = await res.json();

      const formatted = data.map((item) => ({
        id: item.id,
        title: item.name,
        location: item.country,
        link: item.link || "#",
        bgImage: item.image   // 🔥 Correct field for your <img src= >
      }));

      setSlides(formatted);
      setLoading(false);
    } catch (error) {
      console.error("Failed to fetch slides:", error);
      setLoading(false);
    }
  }

  fetchSlides();
}, []);



  return (
    <div className="app">
      <Navbar />
   

<HeroSlider/>
<AboutSection/>

<ServicesSection/>
<WhyChooseUs/>
<FloatingScrollCTA/>

<section id="projects" className="section projects-section">
  <div className="container1">
    <h2 className="section-title" data-aos="fade-up">Our Projects</h2>
    <p className="section-description" data-aos="fade-up" style={{color:'#1c1c1c'}}>
      Discover our curated collection of projects, each a reflection of refined craftsmanship, elegant design, and uncompromising quality.
    </p>
<Swiper
  modules={[Grid, Autoplay]}
  slidesPerView={4}
  grid={{ rows: 2, fill: 'row' }}
  spaceBetween={24}

  autoplay={{
    delay: 2500,
    disableOnInteraction: false,
  }}
breakpoints={{
  0: {         // from 0px and up
    slidesPerView: 1,
    grid: { rows: 1 },
  },
  600: {
    slidesPerView: 2,
    grid: { rows: 2 },
  },
  1024: {
    slidesPerView: 3,
    grid: { rows: 2 },
  },
}}

  className="projects-swiper"
>
  {slides.map((project, index) => (
    <SwiperSlide key={index}>
      <div className="project-card1">
        <img src={project.bgImage} alt={project.title} />
        <div className="overlay">
          <h6>{project.title}</h6>
        </div>
      </div>
    </SwiperSlide>
  ))}
</Swiper>

  </div>

<style jsx>{`
.projects-section {

  padding: 5rem 2rem;
  font-family: 'Poppins', sans-serif;
}

  .section-title {
    text-align: center;
    font-family: 'Playfair Display', serif;
    font-size: 3rem;
    color: #e50914; /* brighter red */
    margin-bottom: 1rem;
  }

  .section-description {
    max-width: 720px;
    margin: 0 auto 3rem;
    text-align: center;
    color: #fff;
    font-size: 1.1rem;
    font-weight: 500;
  }

  .projects-swiper {
    width: 100%;
  }

  .project-card1 {
    height: 330px;
    border-radius: 6px;
    overflow: hidden;
    position: relative;

    transition: transform 0.3s ease;
  }

  .project-card1:hover {
    transform: translateY(-5px);
  }

  .project-card1 img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: opacity 0.4s ease;
  }

  .project-card1:hover img {
    opacity: 0.3;
  }

.project-card1 {
  position: relative;
  height: 330px;
  overflow: hidden;
}

.project-card1 img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.4s ease;
}

/* Don't darken the image on hover */
.project-card1:hover img {
  transform: scale(1.03);
}

/* Updated overlay */
.overlay {
  position: absolute;
  inset: 0;

  display: flex;
  align-items: center;
  justify-content: center;
  color: #e50914;
  font-size: 1.5rem;
  font-weight: 700;
  text-align: center;
  opacity: 0;
  transition: opacity 0.4s ease;
  padding: 1rem;

}

.project-card1:hover .overlay {
  opacity: 1;
}



  .project-card1:hover .overlay {
    opacity: 1;
  }

  @media (max-width: 768px) {
    .section-title {
      font-size: 2.2rem;
    }

    .section-description {
      font-size: 1rem;
      padding: 0 1rem;
    }

    .project-card1 {
      height: 200px;
    }
  }

  @media (max-width: 480px) {
    .project-card1 {
      height: 230px;
    }

    .overlay {
      font-size: 1.1rem;
      padding: 0 0.5rem;
    }
  }
`}</style>

</section>


<section id="clients" className="clients-section">
  <div className="container">

    <h5 className="section-title">Our Valued Clients</h5>

    <p className="section-description" style={{color:"black"}}>
      Trusted by brands who shape excellence with us.
    </p>

    {loading && <p>Loading clients...</p>}

    {!loading && (
      <Swiper
        modules={[Autoplay]}
        slidesPerView={6}
        spaceBetween={30}
        loop
        autoplay={{ delay: 2000 }}
        breakpoints={{
          320: { slidesPerView: 3 },
          600: { slidesPerView: 4 },
          1024: { slidesPerView: 6 }
        }}
      >

        {clients.map((c) => (
          <SwiperSlide key={c.id} className="client-card">

            <div className="logo-wrapper">
              <img src={c.image} alt={c.client_name} />
            </div>

            {/* <p className="client-name">{c.client_name}</p> */}

          </SwiperSlide>
        ))}

      </Swiper>
    )}

  </div>

<style jsx>{`

.clients-section {
  background: linear-gradient(135deg, #f7f7f7, #ffffff);
  padding: 5rem 2rem;
  font-family: 'Poppins', sans-serif;
}

.section-title {
  text-align:center;
  font-size:2.5rem;
  color:#D50032;
}

.section-description {
  text-align:center;
  margin-bottom:3rem;
}

/* ✅ Each client box vertical layout */
.client-card {
  display:flex;
  flex-direction:column;
  align-items:center;
}

.logo-wrapper {
  width: 90px;
  height: 90px;
  background: #fff;
  border-radius: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 8px 24px rgba(0,0,0,0.06);
  transition: 0.3s;
}

.logo-wrapper img {
  width: 70px;        /* FIXED size instead of max-width */
  height: auto;
  object-fit: contain;
  image-rendering: auto;
  backface-visibility: hidden;
  transform: translateZ(0);
  transition: transform 0.3s ease;
}

.logo-wrapper:hover img {
  transform: scale(1.05);
}


/* ✅ Client name under image */
.client-name {
  margin-top:10px;
  font-size:0.85rem;
  color:#d50032;
  font-weight:600;
  text-align:center;
}

@media(max-width:768px){
  .logo-wrapper {
    width:80px;
    height:80px;
  }
}

@media(max-width:480px){
  .logo-wrapper {
    width:70px;
    height:70px;
  }
}

`}</style>

</section>

      <Footer/>
    </div>
  );
};

export default Home;
